module.exports = __webpack_public_path__ + "img/feature_5.ec7d7623.png";